(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yy-bundle-builder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-yy-bb]').forEach(function (root) {
  var minItems = parseInt(root.dataset.yyMin, 10) || 3;
  var maxItems = parseInt(root.dataset.yyMax, 10) || 8;
  if (maxItems < minItems) { maxItems = minItems; }
  var pct   = parseFloat(root.dataset.yyPct) || 0;
  var code  = (root.dataset.yyCode || '').trim();
  var opts  = Array.prototype.slice.call(root.querySelectorAll('[data-yy-opt]'));
  var slots = Array.prototype.slice.call(root.querySelectorAll('[data-yy-slot]'));
  var addBtn = root.querySelector('[data-yy-add]');
  var subEl = root.querySelector('[data-yy-sub]');
  var saveEl = root.querySelector('[data-yy-save]');
  var totEl = root.querySelector('[data-yy-total]');
  var noteEl = root.querySelector('[data-yy-note]');
  var baseNote = noteEl ? noteEl.textContent : '';
  var chosen = [];

  slots.forEach(function (s) {
    var l = s.querySelector('.yy-bb__slott');
    if (l) l.dataset.empty = l.textContent;
  });

  function money(pennies) { return '\u00a3' + (pennies / 100).toFixed(2); }

  function note() {
    if (!noteEl) return;
    var need = minItems - chosen.length;
    if (need > 0) {
      noteEl.textContent = 'add ' + need + ' more to unlock ' + pct + '% off.';
    } else if (chosen.length >= maxItems) {
      noteEl.textContent = maxItems + ' is the most you can add in one go. ' + baseNote;
    } else {
      noteEl.textContent = baseNote;
    }
  }

  function render() {
    var full = chosen.length >= maxItems;
    opts.forEach(function (o) {
      var on = chosen.indexOf(o) !== -1;
      o.classList.toggle('is-on', on);
      o.classList.toggle('is-full', full && !on);
    });

    var visible = Math.min(maxItems, Math.max(minItems, chosen.length + 1));
    slots.forEach(function (s, i) {
      s.classList.toggle('is-hidden', i >= visible);
      var label = s.querySelector('.yy-bb__slott');
      if (chosen[i]) {
        s.classList.add('is-filled');
        label.textContent = chosen[i].dataset.yyTitle.toLowerCase();
      } else {
        s.classList.remove('is-filled');
        label.textContent = label.dataset.empty;
      }
    });

    var sub = chosen.reduce(function (n, o) { return n + parseInt(o.dataset.yyPrice, 10); }, 0);
    var save = chosen.length >= minItems ? Math.round(sub * (pct / 100)) : 0;
    if (subEl) subEl.textContent = money(sub);
    if (saveEl) saveEl.textContent = '-' + money(save);
    if (totEl) totEl.textContent = money(sub - save);
    if (addBtn) addBtn.disabled = chosen.length < minItems;
    note();
  }

  opts.forEach(function (o) {
    o.addEventListener('click', function () {
      var at = chosen.indexOf(o);
      if (at !== -1) { chosen.splice(at, 1); }
      else if (chosen.length < maxItems) { chosen.push(o); }
      render();
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (chosen.length < minItems) return;
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: chosen.map(function (o) { return { id: parseInt(o.dataset.yyId, 10), quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=/cart') : '/cart';
      }).catch(function () {
        addBtn.disabled = false;
        if (noteEl) noteEl.textContent = 'sorry - something went wrong adding those. please try again.';
        setTimeout(note, 4000);
      });
    });
  }

  render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yy-cart-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-yy-cqty-step]');
  if (!btn) return;
  var wrap = btn.closest('[data-yy-cqty]');
  var input = wrap && wrap.querySelector('[data-yy-cqty-input]');
  if (!input) return;
  var next = parseInt(input.value, 10) + parseInt(btn.dataset.yyCqtyStep, 10);
  input.value = next < 0 ? 0 : next;
  var form = input.closest('form');
  if (form) form.submit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yy-product-extras"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-yy-pbb]').forEach(function (root) {
  var minItems = parseInt(root.dataset.min, 10) || 3;
  var maxItems = parseInt(root.dataset.max, 10) || 8;
  if (maxItems < minItems) { maxItems = minItems; }
  var pct = parseFloat(root.dataset.pct) || 0;
  var code = (root.dataset.code || '').trim();
  var opts = Array.prototype.slice.call(root.querySelectorAll('[data-opt]'));
  var slots = Array.prototype.slice.call(root.querySelectorAll('.yy-pbb__slot'));
  var go = root.querySelector('[data-go]');
  var subEl = root.querySelector('[data-sub]');
  var saveEl = root.querySelector('[data-save]');
  var totEl = root.querySelector('[data-total]');
  var noteEl = root.querySelector('[data-note]');
  var baseNote = noteEl ? noteEl.textContent : '';
  var chosen = [];

  slots.forEach(function (s) {
    var l = s.querySelector('.yy-pbb__st');
    if (l) l.dataset.empty = l.textContent;
  });

  function money(p) { return '£' + (p / 100).toFixed(2); }

  function note() {
    if (!noteEl) return;
    var need = minItems - chosen.length;
    if (need > 0) {
      noteEl.textContent = 'add ' + need + ' more to unlock ' + pct + '% off.';
    } else if (chosen.length >= maxItems) {
      noteEl.textContent = maxItems + ' is the most you can add in one go. ' + baseNote;
    } else {
      noteEl.textContent = baseNote;
    }
  }

  function render() {
    var full = chosen.length >= maxItems;
    opts.forEach(function (o) {
      var on = chosen.indexOf(o) !== -1;
      o.classList.toggle('is-on', on);
      o.classList.toggle('is-full', full && !on);
    });

    var visible = Math.min(maxItems, Math.max(minItems, chosen.length + 1));
    slots.forEach(function (s, i) {
      s.classList.toggle('is-hidden', i >= visible);
      var l = s.querySelector('.yy-pbb__st');
      if (chosen[i]) {
        s.classList.add('is-filled');
        l.textContent = chosen[i].dataset.title.toLowerCase();
      } else {
        s.classList.remove('is-filled');
        l.textContent = l.dataset.empty;
      }
    });

    var sub = chosen.reduce(function (n, o) { return n + parseInt(o.dataset.price, 10); }, 0);
    var save = chosen.length >= minItems ? Math.round(sub * (pct / 100)) : 0;
    if (subEl) subEl.textContent = money(sub);
    if (saveEl) saveEl.textContent = '-' + money(save);
    if (totEl) totEl.textContent = money(sub - save);
    if (go) go.disabled = chosen.length < minItems;
    note();
  }

  opts.forEach(function (o) {
    o.addEventListener('click', function () {
      var at = chosen.indexOf(o);
      if (at !== -1) { chosen.splice(at, 1); }
      else if (chosen.length < maxItems) { chosen.push(o); }
      render();
    });
  });

  if (go) {
    go.addEventListener('click', function () {
      if (chosen.length < minItems) return;
      go.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: chosen.map(function (o) { return { id: parseInt(o.dataset.id, 10), quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('fail');
        window.location.href = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=/cart') : '/cart';
      }).catch(function () {
        go.disabled = false;
        if (noteEl) noteEl.textContent = 'sorry - could not add those. please try again.';
        setTimeout(note, 4000);
      });
    });
  }

  render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yy-quiz"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-yy-rq]').forEach(function (root) {
  var dataEl = root.querySelector('[data-rq-data]');
  if (!dataEl) return;
  var ROUTINES = {};
  try { ROUTINES = JSON.parse(dataEl.textContent); }
  catch (e) { if (window.console) console.warn('yy-quiz: routine data did not parse', e); }

  var panels = {};
  root.querySelectorAll('[data-rq-panel]').forEach(function (p) { panels[p.dataset.rqPanel] = p; });

  var prog    = root.querySelector('[data-rq-prog]');
  var fill    = root.querySelector('[data-rq-fill]');
  var stepTxt = root.querySelector('[data-rq-step]');
  var stepsEl = root.querySelector('[data-rq-steps]');
  var emptyEl = root.querySelector('[data-rq-empty]');
  var barEl   = root.querySelector('[data-rq-bar]');
  var totalEl = root.querySelector('[data-rq-total]');
  var metaEl  = root.querySelector('[data-rq-meta]');
  var ledeEl  = root.querySelector('[data-rq-lede]');
  var cautEl  = root.querySelector('[data-rq-caution]');
  var addBtn  = root.querySelector('[data-rq-addall]');
  var msgEl   = root.querySelector('[data-rq-msg]');
  var q2hEl   = root.querySelector('[data-rq-q2h]');
  var q2subEl = root.querySelector('[data-rq-q2sub]');

  var COUNTS = {
    essentials: parseInt(root.dataset.countEssentials, 10) || 2,
    balance:    parseInt(root.dataset.countBalance, 10) || 3,
    full:       parseInt(root.dataset.countFull, 10) || 4
  };
  var LABELS = {
    essentials: root.dataset.labelEssentials || 'just the essentials',
    balance:    root.dataset.labelBalance || 'cleanse + balance',
    full:       root.dataset.labelFull || 'the full ritual'
  };
  var SHIP = root.dataset.freeShip || '';
  var SHOW_RATINGS = root.dataset.showRatings === 'true';
  var REVIEWS_WORD = root.dataset.reviewsWord || 'reviews';
  var STEP_WORD = root.dataset.stepWord || 'step';
  var DONE = root.dataset.doneLabel || 'done';
  var EMPTY_NOTE = root.dataset.emptyNote || '';
  var BASE_Q2H = q2hEl ? q2hEl.textContent : '';
  var BASE_Q2SUB = q2subEl ? q2subEl.textContent : '';

  var answers = { concern: null, depth: null, scent: null };
  var routine = [];
  var baseLede = ledeEl ? ledeEl.textContent : '';
  var steps = 3;
  var trail = [];
  var current = { name: 'intro', step: null };

  function money(p) { return '\u00a3' + (p / 100).toFixed(2); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function show(name, stepN) {
    Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== name; });
    if (prog) prog.hidden = name === 'intro';
    if (stepN != null && stepTxt) {
      if (fill) fill.style.width = Math.min(100, stepN / steps * 100) + '%';
      stepTxt.textContent = stepN >= steps ? DONE : (stepN + 1) + ' / ' + steps;
    }
    var p = panels[name];
    if (p) { p.style.animation = 'none'; void p.offsetWidth; p.style.animation = ''; }
    current = { name: name, step: stepN };
  }

  function advance(name, stepN) { trail.push(current); show(name, stepN); }
  function back() { var prev = trail.pop(); if (prev) show(prev.name, prev.step); }

  function dressQ2(set) {
    var labels = set.labels || {};
    if (q2hEl) q2hEl.textContent = set.q2h || BASE_Q2H;
    if (q2subEl) q2subEl.textContent = set.q2sub || BASE_Q2SUB;
    root.querySelectorAll('[data-rq-depth]').forEach(function (b) {
      var key = b.dataset.rqDepth;
      var span = b.querySelector('.yy-rq__optlbl');
      if (span) span.textContent = labels[key] || LABELS[key];
    });
  }

  function build() {
    var set = ROUTINES[answers.concern] || {};
    var list = (answers.scent === 'b' ? set.b : set.a) || [];
    if (!list.length) list = (set.a && set.a.length ? set.a : set.b) || [];

    var per = set.counts || {};
    var take = set.skipDepth
      ? list.length
      : (per[answers.depth] || COUNTS[answers.depth] || 2);
    routine = list.slice(0, take);

    if (ledeEl) ledeEl.textContent = set.lede || baseLede;
    if (cautEl) {
      if (set.caution) { cautEl.textContent = set.caution; cautEl.hidden = false; }
      else { cautEl.hidden = true; }
    }

    if (!routine.length) {
      stepsEl.innerHTML = '';
      if (emptyEl) { emptyEl.textContent = EMPTY_NOTE; emptyEl.hidden = !EMPTY_NOTE; }
      if (barEl) barEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (barEl) barEl.hidden = false;

    stepsEl.innerHTML = '';
    var total = 0;
    routine.forEach(function (p, i) {
      total += p.price;
      var rate = '';
      if (SHOW_RATINGS && p.rating && p.reviews) {
        rate = '<span class="yy-rq__crate"><span class="yy-stars" style="--yy-fill:' +
               (parseFloat(p.rating) * 20) + '%" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span>' +
               esc(p.rating) + ' \u00b7 ' + esc(p.reviews) + ' ' + esc(REVIEWS_WORD) + '</span>';
      }
      var variant = p.variant ? '<span class="yy-rq__cvar">' + esc(p.variant) + '</span>' : '';
      // priceText has already had its <span class=money> wrapper stripped in
      // Liquid, so escaping it here is safe and prints a plain price.
      var a = document.createElement('a');
      a.className = 'yy-rq__card';
      a.href = p.url;
      a.innerHTML =
        '<span class="yy-rq__cimg">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="yy-rq__cbody">' +
          '<span class="yy-rq__cstep">' + esc(STEP_WORD) + ' ' + (i + 1) + '</span>' +
          '<span class="yy-rq__cname">' + esc(p.title) + '</span>' +
          variant +
          '<span class="yy-rq__cprice">' + esc(p.priceText) + '</span>' +
          rate +
        '</span>';
      stepsEl.appendChild(a);
    });

    if (totalEl) totalEl.textContent = money(total);
    if (metaEl) {
      metaEl.textContent = routine.length + ' ' +
        (routine.length === 1 ? 'product' : 'products') + (SHIP ? ' \u00b7 ' + SHIP : '');
    }
    if (addBtn) addBtn.disabled = false;
  }

  root.querySelectorAll('[data-rq-start]').forEach(function (b) {
    b.addEventListener('click', function () { steps = 3; trail = []; advance('q1', 0); });
  });

  root.querySelectorAll('[data-rq-concern]').forEach(function (b) {
    b.addEventListener('click', function () {
      answers.concern = b.dataset.rqConcern;
      var set = ROUTINES[answers.concern] || {};
      steps = 1 + (set.skipDepth ? 0 : 1) + (set.skipScent ? 0 : 1);

      if (!set.skipDepth) { dressQ2(set); advance('q2', 1); return; }
      answers.depth = null;
      if (!set.skipScent) { advance('q3', 1); return; }
      answers.scent = 'a';
      build();
      advance('result', steps);
    });
  });

  root.querySelectorAll('[data-rq-depth]').forEach(function (b) {
    b.addEventListener('click', function () {
      answers.depth = b.dataset.rqDepth;
      var set = ROUTINES[answers.concern] || {};
      if (!set.skipScent) { advance('q3', 2); return; }
      answers.scent = 'a';
      build();
      advance('result', steps);
    });
  });

  root.querySelectorAll('[data-rq-scent]').forEach(function (b) {
    b.addEventListener('click', function () {
      answers.scent = b.dataset.rqScent;
      build();
      advance('result', steps);
    });
  });

  root.querySelectorAll('[data-rq-prev]').forEach(function (b) {
    b.addEventListener('click', back);
  });

  root.querySelectorAll('[data-rq-restart]').forEach(function (b) {
    b.addEventListener('click', function () {
      answers = { concern: null, depth: null, scent: null };
      routine = [];
      steps = 3;
      trail = [];
      if (msgEl) msgEl.hidden = true;
      if (fill) fill.style.width = '0%';
      show('intro', null);
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (!routine.length) return;

      var gone = routine.filter(function (p) { return !p.available; });
      if (gone.length && msgEl) {
        msgEl.textContent = gone[0].title + ' is out of stock right now.';
        msgEl.hidden = false;
        return;
      }

      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = root.dataset.addingLabel || 'adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: routine.map(function (p) { return { id: p.id, quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/cart';
      }).catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = original;
        if (msgEl) {
          msgEl.textContent = 'sorry - could not add those. please try again.';
          msgEl.hidden = false;
        }
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
